import { FETCH_ACTIVE_PGAPPS_START, FETCH_ACTIVE_PGAPPS_SUCCESS, FETCH_ACTIVE_PGAPPS_FAILURE, UPDATE_NOTIFICATION_SUCCESS, UPDATE_NOTIFICATION_START, UPDATE_NOTIFICATION_FAILURE, GET_UNREAD_NOTIFICATION_START, GET_UNREAD_NOTIFICATION_FAILURE, GET_UNREAD_NOTIFICATION_SUCCESS } from "./appTypes";

export const fetchActivePGApps = () => ({
    type: FETCH_ACTIVE_PGAPPS_START,
}
);


export const fetchActivePGAppSucc = (activeApps) => (
    {
        type: FETCH_ACTIVE_PGAPPS_SUCCESS,
        activeApps
    }
)
export const fetchActivePGAppFailure = (error) => ({
    type: FETCH_ACTIVE_PGAPPS_FAILURE,
    error,
});



export const updateNotification = (payload) => ({
    type: UPDATE_NOTIFICATION_START,
    payload
}
);

export const updateNotificationSuccess = (notification) => (
    {
        type: UPDATE_NOTIFICATION_SUCCESS,
        notification
    }
)
export const updateNotificationFailure = (error) => ({
    type: UPDATE_NOTIFICATION_FAILURE,
    error,
});

export const getUnreadNotification = (email) => ({
    type: GET_UNREAD_NOTIFICATION_START,
    email
}
);

export const getUnreadNotificationSuccess = (notification) => (
    {
        type: GET_UNREAD_NOTIFICATION_SUCCESS,
        notification
    }
)
export const getUnreadNotificationFailure = (error) => ({
    type: GET_UNREAD_NOTIFICATION_FAILURE,
    error,
});